export default "__VITE_ASSET__d3a11bfa__"